import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock, EyeOff, FileText, FlaskConical } from 'lucide-react';
import { Section } from './Shared';
import { FeatherQuill, MoonPhase } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 17,
    s: 52
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('akashico-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 62;
  });
  useEffect(() => {
    sessionStorage.setItem('akashico-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-253">
      <div className="bg-brand-aqua text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-aquaLight/40" data-id="element-254">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-sm font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-255">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-256">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-aqua/40 bg-gradient-to-br from-white/95 to-brand-aquaLight/10 shadow-[0_10px_40px_rgba(13,148,136,0.12)]" data-id="element-257">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-258">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-aqua shrink-0" data-id="element-259" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-darkGreen text-center" data-id="element-260">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-261">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-262" />
          <span className="text-2xl md:text-4xl font-bold text-brand-aqua/60 pb-5" data-id="element-263">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-264" />
          <span className="text-2xl md:text-4xl font-bold text-brand-aqua/60 pb-5" data-id="element-265">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-266" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-267">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-268" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-269">
            Después aumenta.{' '}
            <span className="text-brand-aqua" data-id="element-270">
              No sabemos cuándo volverá esta oferta.
            </span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-aqua/30" data-id="element-271">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-272">
            <div className="flex items-center gap-2" data-id="element-273">
              <span className="relative flex h-2.5 w-2.5" data-id="element-274">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-error opacity-75" data-id="element-275"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-error" data-id="element-276"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-277">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-aqua uppercase tracking-wide" data-id="element-278">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-aqua/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-279">
            <div className="bg-gradient-to-r from-brand-aqua to-brand-darkGreen h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-280" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-281">
            🔥 <strong className="text-brand-aqua" data-id="element-282">{spotsTaken}%</strong> de los
            cupos promocionales ya fueron tomados
          </p>
        </div>
      </div>
    </div>;
};
const tratadoFeatures = ['✅ Cómo construir una identidad profesional coherente.', '✅ Cómo transmitir confianza antes de la primera consulta.', '✅ Cómo comunicar tu trabajo sin sentir que estás vendiendo.', '✅ Cómo diferenciarte de otros terapeutas.', '✅ Cómo presentarte profesionalmente en internet.', '✅ Cómo generar autoridad en tu especialidad.', '✅ Cómo atraer a las personas correctas.', '✅ Cómo dejar de depender exclusivamente del boca a boca.'];
const bonuses = [{
  icon: FileText,
  title: '100 IDEAS DE CONTENIDO PARA TERAPEUTAS',
  pages: '01 GRATIS',
  color: 'text-brand-aqua',
  bgColor: 'bg-brand-aqua/10',
  borderColor: 'border-brand-aqua/30',
  image: 'https://cdn.magicpatterns.com/uploads/egvWw45xGDitqN4GK5GE2H/ChatGPT_Image_22_jun_2026,_04_10_48_p.m..png',
  desc: 'Nunca más te quedes sin saber qué publicar. Ideas listas para adaptar a tu especialidad y generar confianza en tu audiencia.',
  result: '✅ Contenido para meses completos.',
  price: '$12.000'
}, {
  icon: FlaskConical,
  title: '50 REELS QUE GENERAN CONSULTAS',
  pages: '02 GRATIS',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  image: 'https://cdn.magicpatterns.com/uploads/gBrMmSxqecRJyLtUSFbiUi/ChatGPT_Image_22_jun_2026,_04_10_58_p.m..png',
  desc: 'Ejemplos prácticos de contenido diseñado para captar atención y despertar interés en potenciales consultantes.',
  result: '✅ Más alcance y más visibilidad.',
  price: '$15.000'
}, {
  icon: EyeOff,
  title: 'PLANTILLAS DE WHATSAPP',
  pages: '03 GRATIS',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-goldLight/10',
  borderColor: 'border-brand-goldLight/40',
  image: 'https://cdn.magicpatterns.com/uploads/guV29atjhBxRuSZtuV6Ymv/ChatGPT_Image_22_jun_2026,_04_12_51_p.m..png',
  desc: 'Mensajes listos para responder consultas, explicar tus servicios y acompañar potenciales pacientes.',
  result: '✅ Más confianza y menos improvisación.',
  price: '$10.000'
}];
const planComparison = [{
  situation: 'Querés conseguir más consultas',
  without: 'Dependés del boca a boca',
  with: 'Tenés un sistema de visibilidad'
}, {
  situation: 'Querés crecer en Instagram',
  without: 'No sabés qué publicar',
  with: 'Tenés contenido para todo el año'
}, {
  situation: 'Te escriben por WhatsApp',
  without: 'Improvisás respuestas',
  with: 'Tenés mensajes listos para usar'
}, {
  situation: 'Tu agenda tiene espacios vacíos',
  without: 'Esperás recomendaciones',
  with: 'Generás nuevas oportunidades'
}, {
  situation: 'Querés organizar tu consultorio',
  without: 'Todo está disperso',
  with: 'Tenés procesos claros'
}, {
  situation: 'Querés vivir de tus terapias',
  without: 'No sabés por dónde empezar',
  with: 'Tenés un plan concreto'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-283">
      <FeatherQuill className="hidden lg:block absolute top-20 right-[3%] w-8 h-8 opacity-25 animate-float-soft" color="#0D9488" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-284" />
      <MoonPhase className="hidden lg:block absolute top-60 left-[2%] w-10 h-10 opacity-30 animate-float-soft" color="#5EEAD4" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-285" />

      <div className="text-center mb-12" data-id="element-286">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-aqua/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-287">
          <span className="text-xl" data-id="element-288">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-aqua text-sm md:text-base" data-id="element-289">
            KIT DIGITAL PARA TERAPEUTAS™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-darkGreen" data-id="element-290">
          El sistema completo para construir una presencia profesional que
          genere confianza y atraiga consultas.
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-291">
          Todo lo que necesitás para dejar de improvisar y empezar a comunicar
          tu trabajo de forma clara, profesional y estratégica.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-12 space-y-6" data-id="element-292">
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-darkGreen/5 border-brand-darkGreen/30 backdrop-blur-sm shadow-sm" data-id="element-293">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-294">
            <div className="shrink-0 mx-auto md:mx-0 w-32 md:w-40 flex items-center justify-center" data-id="element-295">
              <img src="https://cdn.magicpatterns.com/uploads/vxytVpC9rhwenFMJrWHCYR/ChatGPT_Image_22_jun_2026,_04_04_06_p.m..png" alt="Identidad del Terapeuta Moderno" className="w-full h-auto max-h-[240px] object-contain rounded-md drop-shadow-xl" data-id="element-296" />
            </div>
            <div className="flex-grow" data-id="element-297">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-darkGreen" data-id="element-298">
                📘 IDENTIDAD DEL TERAPEUTA MODERNO™
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-[15px]" data-id="element-299">
                La guía principal que te enseña cómo posicionarte
                profesionalmente, comunicar tu valor y diferenciarte como
                terapeuta.
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-300">
                No importa si hacés Medicina China, Constelaciones, Registros
                Akáshicos, Flores de Bach o cualquier otra terapia. La
                visibilidad funciona igual para todos.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-aqua/15 mb-4" data-id="element-301">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-aqua mb-3" data-id="element-302">
                  ¿QUÉ VAS A APRENDER?
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-303">
                  {tratadoFeatures.map((f, i) => <div key={i} className="flex items-center" data-id="element-304">
                      <span data-id="element-305">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-aqua text-sm" data-id="element-306">
                🌿 Porque tener conocimientos es importante. Pero primero las
                personas necesitan encontrarte.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-8 mt-12" data-id="element-307">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-darkGreen" data-id="element-308">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-309">
            SIEMPRE INCLUIDOS SIN COSTO ADICIONAL
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-310">
          {bonuses.map((bonus, i) => {
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-aqua/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-311">
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] md:text-sm font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-312">
                  {bonus.pages}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-darkGreen text-xs md:text-sm font-bold px-3 py-1 rounded-bl-lg" data-id="element-313">
                  GRATIS
                </div>

                <img src={bonus.image} alt={bonus.title} className="w-24 mx-auto h-auto mt-8 mb-6 rounded-md object-contain drop-shadow-lg" data-id="element-314" />

                <h4 className="text-base font-serif font-bold mb-2 leading-tight text-brand-text" data-id="element-315">
                  {bonus.title}
                </h4>
                <p className="text-brand-text mb-3 text-xs flex-grow" data-id="element-316">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-aqua mb-2" data-id="element-317">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-318">
                  <span data-id="element-319">
                    Valor estimado:{' '}
                    <span className="line-through" data-id="element-320">{bonus.price}</span>
                  </span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-321">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-322">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-aqua/30 bg-white/80" data-id="element-323">
            <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-324">
              🎁 Valor total de los bonus:{' '}
              <span className="line-through text-brand-text/50" data-id="element-325">$37.000</span>{' '}
              <span className="text-brand-aqua font-bold" data-id="element-326">
                → Hoy incluidos GRATIS con tu compra.
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-327" />
      <Pricing data-id="element-328" />

      <div className="max-w-4xl mx-auto mb-12 mt-12" data-id="element-329">
        <div className="bg-white rounded-2xl p-5 md:p-6 border border-brand-aqua/30 shadow-sm" data-id="element-330">
          <p className="text-base md:text-lg font-semibold text-brand-darkGreen mb-4 text-center" data-id="element-331">
            🎓 ¿QUÉ AGREGA EL MEGAPACK DIGITAL?
          </p>

          <div className="hidden md:block" data-id="element-332">
            <div className="grid grid-cols-3 gap-2 text-[11px] md:text-sm font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-aqua/20 pb-2 mb-2" data-id="element-333">
              <div data-id="element-334">Situación</div>
              <div className="text-brand-error" data-id="element-335">❌ Sin Megapack</div>
              <div className="text-brand-aqua" data-id="element-336">✅ Con Megapack</div>
            </div>
            <div className="space-y-2" data-id="element-337">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-2 text-xs md:text-sm text-brand-text py-1.5 border-b border-brand-aqua/10 last:border-0" data-id="element-338">
                  <div className="font-medium" data-id="element-339">{row.situation}</div>
                  <div className="text-brand-error/80" data-id="element-340">{row.without}</div>
                  <div className="text-brand-aqua font-medium" data-id="element-341">{row.with}</div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-3" data-id="element-342">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-aqua/15 pb-3 last:border-0 last:pb-0" data-id="element-343">
                <p className="text-xs font-semibold text-brand-text mb-1.5" data-id="element-344">
                  {row.situation}
                </p>
                <div className="text-[11px] text-brand-error/80 mb-0.5" data-id="element-345">
                  ❌ {row.without}
                </div>
                <div className="text-[11px] text-brand-aqua font-medium" data-id="element-346">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm font-medium text-brand-goldDark italic text-center mt-5" data-id="element-347">
            🌿 Un solo paciente nuevo puede recuperar la inversión completa.
          </p>
        </div>
      </div>
    </Section>;
};